import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchFooter } from '../services';

// Valores por defecto para el footer
const defaultFooterData = {
    social_media: {
        facebook_enabled: 1,
        facebook_url: "https://www.facebook.com/RainbowAgrosciences",
        youtube_enabled: 1,
        youtube_url: "https://www.youtube.com/channel/UCTWsHDwzkSYODrTY6kowDWw",
        instagram_enabled: 1,
        instagram_url: "https://www.instagram.com/rainbow.agro",
        linkedin_enabled: 1,
        linkedin_url: "https://www.linkedin.com/company/rainbow-agro/",
        twitter_enabled: 1,
        twitter_url: "https://twitter.com/RainbowAgro",
        tiktok_enabled: 0,
        tiktok_url: null
    },
    custom_links: [],
    terms_conditions_text: "",
    privacy_policy_text: "",
    last_report_src: ""
};

// Thunk asíncrono para obtener los datos de footer desde la API
export const fetchFooterData = createAsyncThunk(
    'footer/fetchFooterData',
    async (_, { rejectWithValue }) => {
        try {
            const data = await fetchFooter(); // Llama al servicio de la API
            return data;
        } catch (error) {
            return rejectWithValue(error.message); // Manejo de errores
        }
    }
);

const footerSlice = createSlice({
    name: 'footer',
    initialState: {
        data: defaultFooterData, // Usa los valores por defecto en lugar de null
        loading: false,
        error: null,
    },
    reducers: {
        // Puedes agregar más acciones sincronas si es necesario
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchFooterData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchFooterData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchFooterData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default footerSlice.reducer;
